"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Helper = void 0;
const gs = require("@ivanlog/gs");
const models_1 = require("./api/classes/models");
const App_1 = require("./App");
class Helper {
    constructor() { }
    static getOrderStatusDescriptionsRu(status) {
        switch (status) {
            case models_1.OrderStatusEnum.Unknown:
                return {
                    title: "Неизвестно",
                    description: "Статус заказа не определён"
                };
            case models_1.OrderStatusEnum.Created:
                return {
                    title: "Создан",
                    description: "Заказ был успешно создан"
                };
            case models_1.OrderStatusEnum.Confirming:
                return {
                    title: "Подтверждается",
                    description: "Заказ в процессе подтверждения"
                };
            case models_1.OrderStatusEnum.NeedPay:
                return {
                    title: "Ожидает оплаты",
                    description: "Заказ ожидает оплаты от клиента"
                };
            case models_1.OrderStatusEnum.NeedCollect:
                return {
                    title: "Ожидает сборки",
                    description: "Заказ поставлен в очередь на сборку"
                };
            case models_1.OrderStatusEnum.Collecting:
                return {
                    title: "В сборке",
                    description: "Заказ собирается"
                };
            case models_1.OrderStatusEnum.Collected:
                return {
                    title: "Собран",
                    description: "Сборка заказа завершена"
                };
            case models_1.OrderStatusEnum.InDelivery:
                return {
                    title: "В доставке",
                    description: "Заказ передан в доставку"
                };
            case models_1.OrderStatusEnum.IssuedToCustomer:
                return {
                    title: "Выдан клиенту",
                    description: "Заказ выдан клиенту"
                };
            case models_1.OrderStatusEnum.Payed:
                return {
                    title: "Оплачен",
                    description: "Заказ был успешно оплачен"
                };
            case models_1.OrderStatusEnum.Done:
                return {
                    title: "Завершён",
                    description: "Заказ полностью завершён"
                };
            case models_1.OrderStatusEnum.CanceledByManager:
                return {
                    title: "Отменён менеджером",
                    description: "Заказ отменён сотрудником"
                };
            case models_1.OrderStatusEnum.CanceledByCustomer:
                return {
                    title: "Отменён клиентом",
                    description: "Заказ отменён клиентом"
                };
            case models_1.OrderStatusEnum.CanceledViaChangeByMasterSystem:
                return {
                    title: "Отменён системой (изменения)",
                    description: "Система отменила заказ из-за изменений"
                };
            case models_1.OrderStatusEnum.RejectedByMasterSystem:
                return {
                    title: "Отклонён системой",
                    description: "Заказ отклонён системой"
                };
            default:
                return {
                    title: "Неизвестный статус",
                    description: "Неизвестный код статуса заказа"
                };
        }
    }
    // public static getUserPhone(user:User, def:any=""):string|any
    // {
    //     const auth = user.auths.find(a=>a.authType==AuthTypeEnum[AuthTypeEnum.Phone]);
    //     if (!auth) return def;
    //     return auth.data;
    // }
    // public static getUserEmail(user:User, def:any=""):string|any
    // {
    //     const auth = user.auths.find(a=>a.authType==AuthTypeEnum[AuthTypeEnum.Email]);
    //     if (!auth) return def;
    //     return auth.data;
    // }
    static toPriceString(price) {
        let result = (price.toFixed(2) + "").replace(/\B(?=(\d{3})+(?!\d))/g, " ");
        result = result.replace(/\./g, ",");
        return result + " ₽";
    }
    static toVolWeightString(weight) {
        let result = (weight).toFixed(3) + "";
        result = result.replace(/\./g, ",");
        return result;
    }
    static scrollTo(wr, deltaY = 0) {
        let e = wr.el, posX = 0, posY = 0;
        while (e) {
            posX += e.offsetLeft;
            posY += e.offsetTop;
            e = gs.def.toType(e.offsetParent, HTMLElement);
        }
        window.scrollTo(posX, posY + deltaY);
    }
    static userHasAccess(user, access, ignoreSuperAdmin = false) {
        const hasAccess = ignoreSuperAdmin ?
            user.accesses.find((a) => a.type == access) :
            user.accesses.find((a) => a.type == access || a.type == models_1.AccessTypeEnum.SuperAdmin);
        if (hasAccess)
            return true;
        return false;
    }
    static userHasAccesses(user, accesses, ignoreSuperAdmin = false) {
        for (const access of accesses) {
            const hasAccess = ignoreSuperAdmin ?
                user.accesses.find((a) => a.type == access) :
                user.accesses.find((a) => a.type == access || a.type == models_1.AccessTypeEnum.SuperAdmin);
            if (hasAccess)
                return true;
        }
        return false;
    }
    // public static fillObjByLocalizeString(fieldName:string, obj:any, localString:LocalizedString)
    // {
    //     obj[fieldName+"_en"]=localString.en;
    //     obj[fieldName+"_ru"]=localString.ru;
    // }
    // public static LocalizedStringFromObj(fieldName:string, obj:any)
    // {
    //     const str = new LocalizedString({en:obj[fieldName+"_en"], ru:obj[fieldName+"_ru"]});
    //     return str;
    // }
    // public static async uploadImgFileAsync(file:File, fileCategory:FileCategoryEnum):Promise<FileDescriptor>
    // {
    //  //   const xsrf = await AppYB.Inst.api.files.getAntiForgeryTokenUnsafe();
    //     const response = await App.Inst.api.files.upload(fileCategory, file, {skip:true});
    //     return response;
    // }
    // public static async resizeToMaxCheckAndUploadImgFile(file:File, resizeToMaxSize:number, fileCategory:FileCategoryEnum):Promise<FileDescriptor>
    // {
    //     const img = await gs.blob.imageFileToResizedBlob(file, resizeToMaxSize);
    //     const bytes = await img.arrayBuffer();            
    //     const sha256 = gs.crypt.bytesToSHA256(bytes).toUpperCase();
    //     let info = await App.Inst.gui.lockAction(App.Inst.api.files.getFileDescriptionByHashAndCategory(sha256, fileCategory, {skip:true}));
    //     if (!info)
    //         info = await Helper.uploadImgFileAsync(gs.blob.blobToFile(img, file.name), fileCategory);
    //     return info;
    // }
    // public static async resizeCuttedCheckAndUploadImgFile(file:File, cutToSize:number, fileCategory:FileCategoryEnum):Promise<FileDescriptor>
    // {
    //     const img = await gs.blob.imageFileToCuttedResizedSquareBlob(file, cutToSize);
    //     const bytes = await img.arrayBuffer();            
    //     const sha256 = gs.crypt.bytesToSHA256(bytes).toUpperCase();
    //     let info = await App.Inst.gui.lockAction(App.Inst.api.files.getFileDescriptionByHashAndCategory(sha256, fileCategory, {skip:true}));
    //     if (!info)
    //         info = await Helper.uploadImgFileAsync(gs.blob.blobToFile(img, file.name), fileCategory);
    //     return info;
    // }
    static loadYandexMapAsync() {
        return new Promise(function (resolve, reject) {
            const script = document.createElement('script');
            script.src = `https://api-maps.yandex.ru/2.1/?apikey=${App_1.App.MAP_API}&suggest_apikey=${App_1.App.MAP_SUGGEST_API}&lang=ru_RU`;
            script.async = true;
            script.defer = true;
            script.onload = () => globalThis.ymaps.ready(resolve);
            script.onerror = reject;
            document.head.appendChild(script);
        });
    }
    static awaitTime(timeMS) {
        return new Promise((resolve, reject) => {
            setTimeout(() => resolve(), timeMS);
        });
    }
    static addEnterPressEvent(el, callback) {
        el.addEventListener('keydown', (e) => __awaiter(this, void 0, void 0, function* () {
            let ev = e;
            if (ev.key === 'Enter' || ev.keyCode === 13)
                callback();
        }));
    }
}
exports.Helper = Helper;
//# sourceMappingURL=Helper.js.map